/* src/app/system-list/system-list.component.css */
.toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  align-items: flex-end;
  margin-bottom: 16px;
  padding: 16px 20px 0 20px;
}
.info-key-field {
  min-width: 220px;
}
.column-selector {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
  min-width: 260px;
  gap: 12px;
}
.column-selector mat-form-field {
  flex: 1;
  min-width: 180px;
}
/*# sourceMappingURL=system-list.component.css.map */
